<!-- The week and month views (E4 RF-42). Hyper card; Material Design Icons throughout. -->
<div class="card">
  <div class="card-body">
    <div class="d-flex flex-wrap justify-content-between align-items-center gap-2 mb-3">
      <div class="d-flex align-items-center gap-2">
        <div class="btn-group" role="group">
          <button type="button" class="btn btn-outline-secondary" (click)="previous()" [attr.aria-label]="'task.range.previous' | translate">
            <i class="mdi mdi-chevron-left"></i>
          </button>
          <button type="button" class="btn btn-outline-secondary" (click)="today()">
            {{ 'task.range.today' | translate }}
          </button>
          <button type="button" class="btn btn-outline-secondary" (click)="next()" [attr.aria-label]="'task.range.next' | translate">
            <i class="mdi mdi-chevron-right"></i>
          </button>
        </div>
        <h5 class="header-title mb-0">
          @if (mode === 'week') {
            {{ periodStart | date: 'd MMM' }} – {{ periodEnd | date: 'd MMM y' }}
          } @else {
            {{ periodStart | date: 'MMMM y' }}
          }
        </h5>
      </div>
      <!-- RF-42: the overdue count of this result. -->
      @if (reading) {
        <span class="badge campaign-badge" [ngClass]="reading.overdueCount > 0 ? 'is-err' : 'is-ok'" [attr.aria-label]="'task.range.overdue' | translate: { count: reading.overdueCount }">
          <i class="mdi me-1" [ngClass]="reading.overdueCount > 0 ? 'mdi-alert-circle-outline' : 'mdi-check-circle-outline'"></i>
          {{ 'task.range.overdue' | translate: { count: reading.overdueCount } }}
        </span>
      }
    </div>

    @if (failed && !reading) {
      <div class="alert alert-danger py-2 mb-0" role="alert">
        <i class="mdi mdi-alert-circle-outline me-1"></i>{{ 'task.range.loadError' | translate }}
      </div>
    } @else if (loading && !reading) {
      <content-loading-list />
    } @else if (!days.length) {
      <empty-records-component icon="ri-calendar-line" [message]="'task.range.empty' | translate" />
    } @else {
      <!--
        Design (canvas "Semana", 2026-10-07): the days are an accordion — one item per day, the day's
        activities inside. The open state is Angular's, not Bootstrap's data attributes, so it survives
        the 60 s reload and today starts unfolded (`openDays`).
      -->
      <div class="accordion accordion-flush" id="rangeDays">
        @for (day of days; track day.day) {
          <div class="accordion-item">
            <h2 class="accordion-header" [id]="'range-day-heading-' + day.day">
              <button
                type="button"
                class="accordion-button"
                [class.collapsed]="!isOpen(day)"
                [attr.aria-expanded]="isOpen(day)"
                [attr.aria-controls]="'range-day-' + day.day"
                (click)="toggleDay(day)"
              >
                <span class="d-inline-flex align-items-center gap-2" [class.text-primary]="isToday(day)">
                  <i class="mdi mdi-calendar-today"></i>
                  {{ day.date | date: 'EEEE, d MMM' }}
                  <span class="badge bg-soft-secondary text-muted">{{ day.activities.length }}</span>
                </span>
              </button>
            </h2>
            <div
              [id]="'range-day-' + day.day"
              class="accordion-collapse collapse"
              [class.show]="isOpen(day)"
              [attr.aria-labelledby]="'range-day-heading-' + day.day"
            >
              <div class="accordion-body">
                <app-activity-list
                  [activities]="day.activities"
                  [showResponsible]="!!reading?.responsible === false"
                  timedFormat="HH:mm"
                  dateFormat="DD/MM"
                  (changed)="onChanged()"
                />
              </div>
            </div>
          </div>
        }
      </div>
    }
  </div>
</div>
